module.exports = __webpack_public_path__ + "static/img/CA-LSR.85e9552.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/CA-LSR.jpg
// module id = S+7V
// module chunks = 1